import React from 'react';
import './SubtopicBox.css';

const SubtopicBox = ({ name, streak, lastStudied, mastery, color, flipped }) => (
	//console.log('color', color),
	<div className="subtopic-card">
		<div className="subtopic-details">
			<div className="subtopic-title">{name}</div>
			<span>🔥 Streak: {streak} Days</span>
			<span>🔵 Last Studied: {lastStudied || 'N/A'}</span>
		</div>
		{/* <div
			className="progress-circle"
			style={{
				backgroundColor: `${color}`, // Light background using the specific color
				color: `${color}`, // Text color using the specific color
				borderColor: `${color}`, // Border color using the specific color
			}}
		>
			<span>{Math.round(mastery * 100)}%</span>
		</div> */}
		<div className="progress-ring">
			<svg className="progress-ring__svg" width="60" height="60">
				<circle
					className="progress-ring__bg"
					stroke="#e6f2ec"
					strokeWidth="6"
					fill="transparent"
					r="26"
					cx="30"
					cy="30"
				/>
				<circle
					className="progress-ring__circle"
					stroke={color || '#00cc66'}
					strokeWidth="6"
					fill="transparent"
					r="26"
					cx="30"
					cy="30"
					strokeDasharray={2 * Math.PI * 26}
					strokeDashoffset={(1 - mastery) * 2 * Math.PI * 26}
				/>
			</svg>
			<div className="progress-ring__text">{Math.round(mastery * 100)}%</div>
		</div>
	</div>
);

export default SubtopicBox;
